module.exports = __webpack_public_path__ + "static/media/battles.0ed6a26a.png";